import { render } from "./AutoLogout.vue?vue&type=template&id=cf0f1ace"
import script from "./AutoLogout.vue?vue&type=script&lang=js"
export * from "./AutoLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__